import React from 'react';
import { KeyboardDatePicker } from 'seagull';
const toFromErrorMessage = 'To date must be after from date';
const DateRangePicker = _ref => {
  let {
    fromDate,
    toDate,
    testid,
    dateLimits = {},
    onChange,
    onInputBlur,
    onInputFocus
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    label: "From",
    "data-testid": testid && "".concat(testid, "-from"),
    value: fromDate,
    minDate: dateLimits.min,
    maxDate: toDate,
    minDateMessage: dateLimits.minDateMessage,
    maxDateMessage: toFromErrorMessage,
    onChange: function (_onChange) {
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }
      onChange.toString = function () {
        return _onChange.toString();
      };
      return onChange;
    }(date => date && onChange({
      fromDate: date,
      toDate
    })),
    onFocus: onInputFocus,
    onBlur: onInputBlur
  }), /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    label: "To",
    "data-testid": testid && "".concat(testid, "-to"),
    value: toDate,
    minDate: fromDate,
    maxDate: dateLimits.max,
    minDateMessage: toFromErrorMessage,
    maxDateMessage: dateLimits.maxDateMessage,
    onChange: function (_onChange2) {
      function onChange(_x2) {
        return _onChange2.apply(this, arguments);
      }
      onChange.toString = function () {
        return _onChange2.toString();
      };
      return onChange;
    }(date => date && onChange({
      fromDate,
      toDate: date
    })),
    onFocus: onInputFocus,
    onBlur: onInputBlur
  }));
};
export default DateRangePicker;